import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StructuredData from "@/components/StructuredData";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <>
      <StructuredData />
      <Header />
      <main id="main" data-testid="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
